var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.1811 1.83139L19.389 2.28614V2.28614L19.1811 1.83139ZM2.81886 1.83139L2.61099 2.28613H2.61099L2.81886 1.83139ZM11 11L10.5246 11.1549L11 12.6137L11.4754 11.1549L11 11ZM20.7921 0.545254L18.9733 1.37664L19.389 2.28614L21.2079 1.45475L20.7921 0.545254ZM3.02672 1.37664L1.20786 0.545254L0.792139 1.45475L2.61099 2.28613L3.02672 1.37664ZM11.4754 10.8451C10.1071 6.64636 7.04307 3.21249 3.02672 1.37664L2.61099 2.28613C6.37299 4.00571 9.24298 7.22211 10.5246 11.1549L11.4754 10.8451ZM18.9733 1.37664C14.9569 3.21249 11.8929 6.64636 10.5246 10.8451L11.4754 11.1549C12.757 7.22211 15.627 4.00572 19.389 2.28614L18.9733 1.37664Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.f95eae483de10b2f540c637256a1548f.svg";
export { ForwardRef as ReactComponent };